import React from 'react';
import stats from '../data/stats';
import Icons from './Icons';

export default function Stats() {
	return (
		<section className="py-12 bg-white">
			<div className="max-w-7xl mx-auto px-4 grid grid-cols-2 md:grid-cols-4 gap-6">
				{stats.map((s, i) => (
					<div key={i} className="text-center">
						<div className="inline-flex items-center justify-center w-12 h-12 bg-mineral-50 rounded-full mb-2">{React.createElement(Icons[s.icon])}</div>
						<div className="text-2xl font-bold text-mineral-700">{s.value}</div>
						<div className="text-sm text-slate-500">{s.label}</div>
					</div>
				))}
			</div>
		</section>
	);
}
